import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { resolveServerApiUrl } from './server-api-url.util';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  req = req.clone({
    url: resolveServerApiUrl(req.url, isPlatformServer(platformId)),
    setHeaders: { 'X-ot-session-mode': 'cookie' },
    withCredentials: true,
  });

  return next(req);
};
